import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { AgenciesService, AgenciesWithBrandCodes } from 'src/Services/API';

export const useGetAgencyListWithBrandCodes = (
  config?: UseQueryOptions<AgenciesWithBrandCodes, Error>
) => {
  return useQuery<AgenciesWithBrandCodes, Error>(
    ['agency-list'],
    async () => {
      const data = await AgenciesService.agenciesControllerGetConsultantAgencies();
      data.agencies.sort();
      return data;
    },
    {
      refetchOnWindowFocus: false,
      ...config,
    }
  );
};

export interface ConsultantAgencies {
  defaultAgency?: string;

  agencies: string[];
}

export const useGetAgencyList = (config?: UseQueryOptions<ConsultantAgencies, Error>) => {
  return useQuery<ConsultantAgencies, Error>(
    ['agency-list'],
    async () => {
      const data = await AgenciesService.agenciesControllerGetConsultantAgencies();
      data.agencies.sort();
      return {
        defaultAgency: data.defaultAgency,
        agencies: data.agencies.flatMap(a => a.agencies),
      };
    },
    {
      refetchOnWindowFocus: false,
      ...config,
    }
  );
};
